import { render, staticRenderFns } from "./PersistStatusSmsView.vue?vue&type=template&id=53abb295&"
import script from "./PersistStatusSmsView.vue?vue&type=script&lang=ts&"
export * from "./PersistStatusSmsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports